    /**
     * @ngdoc control
     * @name EntityTemplateNavListCtrl
     * 
     * @description
     * Controller which is used for viewing the entity templates, clicking on an entity template will navigate to the relevant entities list.
     */

(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntityTemplateNavListCtrl', EntityTemplateNavListCtrl);

    EntityTemplateNavListCtrl.$inject = ['EntityTemplatesService', 'WindowTitleService'];

    function EntityTemplateNavListCtrl(EntityTemplatesService, WindowTitleService) {
        /* jshint validthis:true */
        var vm = this;
        vm.getLink = getLink;
        vm.loading = true;

        activate();

        function activate() {
            WindowTitleService.setTitle('Entities');
            loadEntityTemplates();
        }

        function getLink(entityTemplate) {
            return '#/entities' + '?entityTemplateId=' + entityTemplate.Id;
        }

        function loadEntityTemplates() {
            return EntityTemplatesService.query(
                {
                    summary: true,
                    active: true,
                    standalone: true,
                    usergranted: true,
                    excludeentitytypes: ['User', 'Organisation']
                })
                .then(getEntityTemplatesOk, getEntityTemplatesError);

            function getEntityTemplatesOk(data) {
                vm.entityTemplates = _.sortBy(data, function (entityTemplate) { return entityTemplate.Name; });
                vm.loading = false;
            }

            function getEntityTemplatesError(response) {
                vm.error = 'Error fetching entity templates';
                vm.loading = false;
            }
        }
    }
})();
